
import Layout from "@/components/layout/Layout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Zap, Home, Save, ArrowLeft } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Separator } from "@/components/ui/separator";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const EnergiaConfiguracao = () => {
  const handleSave = () => {
    toast.success("Configurações salvas com sucesso");
  };

  return (
    <Layout>
      <div className="container mx-auto px-4 py-6 max-w-4xl">
        <div className="mb-6 flex flex-col md:flex-row justify-between items-start md:items-center">
          <div>
            <h1 className="text-2xl font-bold text-blue-600">Configurações</h1>
            <p className="text-muted-foreground">Configurações do módulo de energia</p>
          </div>
          <div className="mt-4 md:mt-0 flex flex-wrap gap-2">
            <Button asChild variant="outline">
              <Link to="/energia">
                <Zap className="h-4 w-4 mr-2" />
                Dashboard Energia
              </Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/dashboard">
                <Home className="h-4 w-4 mr-2" />
                Dashboard Geral
              </Link>
            </Button>
          </div>
        </div>

        <Tabs defaultValue="geral" className="w-full">
          <TabsList className="mb-4 bg-blue-50">
            <TabsTrigger value="geral" className="data-[state=active]:bg-blue-600 data-[state=active]:text-white">Configurações Gerais</TabsTrigger>
            <TabsTrigger value="tarifas" className="data-[state=active]:bg-blue-600 data-[state=active]:text-white">Tarifas</TabsTrigger>
          </TabsList>
          
          <TabsContent value="geral">
            <Card>
              <CardHeader>
                <CardTitle>Configurações Gerais</CardTitle>
                <CardDescription>
                  Ajuste os parâmetros gerais do módulo de energia
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="space-y-4">
                  <h3 className="text-lg font-medium">Preferências</h3>
                  <Separator />
                  
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <Label htmlFor="tarifa">Tarifa padrão (kWh)</Label>
                      <Input id="tarifa" type="number" step="0.01" placeholder="0.92" className="border-blue-200 focus-visible:ring-blue-400" />
                      <p className="text-xs text-muted-foreground">
                        Valor padrão usado para cálculos
                      </p>
                    </div>
                    
                    <div className="space-y-2">
                      <Label htmlFor="moeda">Formato da moeda</Label>
                      <Select defaultValue="BRL">
                        <SelectTrigger id="moeda" className="border-blue-200 focus-visible:ring-blue-400">
                          <SelectValue placeholder="Selecione o formato" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="BRL">Real Brasileiro (R$)</SelectItem>
                          <SelectItem value="USD">Dólar Americano ($)</SelectItem>
                          <SelectItem value="EUR">Euro (€)</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <div className="space-y-0.5">
                      <Label htmlFor="auto-refresh">Auto atualização</Label>
                      <p className="text-xs text-muted-foreground">
                        Atualizar dados automaticamente
                      </p>
                    </div>
                    <Switch id="auto-refresh" defaultChecked />
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="tarifas">
            <Card>
              <CardHeader>
                <CardTitle>Configurações de Tarifas</CardTitle>
                <CardDescription>
                  Tarifas por concessionária
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="space-y-4">
                  <h3 className="text-lg font-medium">Concessionárias</h3>
                  <Separator />
                  
                  {['CEMIG', 'CPFL', 'ENEL'].map((concessionaria, index) => (
                    <div key={index} className="grid md:grid-cols-2 gap-4 p-3 bg-muted/10 rounded-lg">
                      <div className="space-y-2">
                        <Label>{concessionaria}</Label>
                        <p className="text-xs text-muted-foreground">
                          Tarifa atual: R$ {(0.8 + index * 0.05).toFixed(2)}/kWh
                        </p>
                      </div>
                      
                      <div className="space-y-2">
                        <Label htmlFor={`tarifa-${index}`}>Nova tarifa (kWh)</Label>
                        <div className="flex space-x-2">
                          <Input id={`tarifa-${index}`} type="number" step="0.01" placeholder={(0.8 + index * 0.05).toFixed(2)} className="border-blue-200 focus-visible:ring-blue-400" />
                          <Button size="sm" className="bg-blue-600 hover:bg-blue-700">Atualizar</Button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
        
        <div className="mt-6 flex justify-end">
          <Button className="bg-blue-600 hover:bg-blue-700" onClick={handleSave}>
            <Save className="h-4 w-4 mr-2" />
            Salvar Configurações
          </Button>
        </div>
      </div>
    </Layout>
  );
};

export default EnergiaConfiguracao;
